/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Cookies_TitleInputs */

const en_privacy_cookies_title = /** @type {(inputs: Privacy_Cookies_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Cookies and Similar Technologies`)
};

const de_privacy_cookies_title = /** @type {(inputs: Privacy_Cookies_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Cookies und aehnliche Technologien`)
};

const fr_privacy_cookies_title = /** @type {(inputs: Privacy_Cookies_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Cookies et technologies similaires`)
};

const es_privacy_cookies_title = /** @type {(inputs: Privacy_Cookies_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Cookies y tecnologías similares`)
};

const it_privacy_cookies_title = /** @type {(inputs: Privacy_Cookies_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Cookie e tecnologie simili`)
};

const nl_privacy_cookies_title = /** @type {(inputs: Privacy_Cookies_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Cookies en vergelijkbare technologieën`)
};

const pl_privacy_cookies_title = /** @type {(inputs: Privacy_Cookies_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Ciasteczka i podobne technologie`)
};

const fi_privacy_cookies_title = /** @type {(inputs: Privacy_Cookies_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Evästeet ja vastaavat teknologiat`)
};

const da_privacy_cookies_title = /** @type {(inputs: Privacy_Cookies_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Cookies og lignende teknologier`)
};

const sv_privacy_cookies_title = /** @type {(inputs: Privacy_Cookies_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Cookies och liknande tekniker`)
};

/**
* | output |
* | --- |
* | "8. Cookies and Similar Technologies" |
*
* @param {Privacy_Cookies_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_cookies_title = /** @type {((inputs?: Privacy_Cookies_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Cookies_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_cookies_title(inputs)
	if (locale === "fr") return fr_privacy_cookies_title(inputs)
	if (locale === "es") return es_privacy_cookies_title(inputs)
	if (locale === "it") return it_privacy_cookies_title(inputs)
	if (locale === "nl") return nl_privacy_cookies_title(inputs)
	if (locale === "pl") return pl_privacy_cookies_title(inputs)
	if (locale === "fi") return fi_privacy_cookies_title(inputs)
	if (locale === "da") return da_privacy_cookies_title(inputs)
	if (locale === "sv") return sv_privacy_cookies_title(inputs)
	return en_privacy_cookies_title(inputs)
});